import * as React from 'react';
import * as ReactDOM from 'react-dom';
import CloseOutlined from '@ant-design/icons/CloseOutlined';
import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined';
import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined';
import CheckCircleFilled from '@ant-design/icons/CheckCircleFilled';
import ExclamationCircleFilled from '@ant-design/icons/ExclamationCircleFilled';
import InfoCircleFilled from '@ant-design/icons/InfoCircleFilled';
import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled';
import Animate from 'rc-animate';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
import getDataOrAriaProps from '../_util/getDataOrAriaProps';
import ErrorBoundary from './ErrorBoundary';
import { replaceElement } from '../_util/reactNode';
const iconMapFilled = {
    success: CheckCircleFilled,
    info: InfoCircleFilled,
    error: CloseCircleFilled,
    warning: ExclamationCircleFilled,
};
const iconMapOutlined = {
    success: CheckCircleOutlined,
    info: InfoCircleOutlined,
    error: CloseCircleOutlined,
    warning: ExclamationCircleOutlined,
};
let Alert = /** @class */ (() => {
    class Alert extends React.Component {
        constructor() {
            super(...arguments);
            this.state = {
                closing: false,
                closed: false,
            };
            this.handleClose = (e) => {
                var _a, _b;
                e.preventDefault();
                const dom = ReactDOM.findDOMNode(this);
                dom.style.height = `${dom.offsetHeight}px`;
                // Magic code
                // 重复一次后才能正确设置 height
                dom.style.height = `${dom.offsetHeight}px`;
                this.setState({
                    closing: true,
                });
                (_b = (_a = this.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            };
            this.animationEnd = () => {
                var _a, _b;
                this.setState({
                    closing: false,
                    closed: true,
                });
                (_b = (_a = this.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
            };
            this.renderAlert = ({ getPrefixCls, direction }) => {
                const { description, prefixCls: customizePrefixCls, message, banner, className = '', style, onMouseEnter, onMouseLeave, onClick, } = this.props;
                const { closing, closed } = this.state;
                const prefixCls = getPrefixCls('alert', customizePrefixCls);
                const isShowIcon = this.getShowIcon();
                const type = this.getType();
                const closable = this.getClosable();
                const alertCls = classNames(prefixCls, `${prefixCls}-${type}`, {
                    [`${prefixCls}-closing`]: closing,
                    [`${prefixCls}-with-description`]: !!description,
                    [`${prefixCls}-no-icon`]: !isShowIcon,
                    [`${prefixCls}-banner`]: !!banner,
                    [`${prefixCls}-closable`]: closable,
                    [`${prefixCls}-rtl`]: direction === 'rtl',
                }, className);
                const closeIcon = this.renderCloseIcon({ prefixCls });
                const dataOrAriaProps = getDataOrAriaProps(this.props);
                const iconNode = this.renderIconNode({ prefixCls });
                return closed ? null : (<Animate component="" showProp="data-show" transitionName={`${prefixCls}-slide-up`} onEnd={this.animationEnd}>
        <div data-show={!closing} className={alertCls} style={style} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick} {...dataOrAriaProps}>
          {isShowIcon ? iconNode : null}
          <span className={`${prefixCls}-message`}>{message}</span>
          <span className={`${prefixCls}-description`}>{description}</span>
          {closeIcon}
        </div>
      </Animate>);
            };
        }
        getShowIcon() {
            const { banner, showIcon } = this.props;
            // banner 模式默认有 Icon
            return banner && showIcon === undefined ? true : showIcon;
        }
        getType() {
            const { banner, type } = this.props;
            if (type !== undefined) {
                return type;
            }
            // banner 模式默认为警告
            return banner ? 'warning' : 'info';
        }
        getClosable() {
            const { closable, closeText } = this.props;
            // closeable when closeText is assigned
            return closeText ? true : closable;
        }
        getIconType() {
            const { description } = this.props;
            // use outline icon in alert with description
            return (description ? iconMapOutlined : iconMapFilled)[this.getType()] || null;
        }
        renderIconNode({ prefixCls }) {
            const { icon } = this.props;
            const iconType = this.getIconType();
            if (icon) {
                return replaceElement(icon, <span className={`${prefixCls}-icon`}>{icon}</span>, () => ({
                    className: classNames(`${prefixCls}-icon`, {
                        [icon.props.className]: icon.props.className,
                    }),
                }));
            }
            return React.createElement(iconType, { className: `${prefixCls}-icon` });
        }
        renderCloseIcon({ prefixCls }) {
            const { closeText } = this.props;
            return this.getClosable() ? (<button type="button" onClick={this.handleClose} className={`${prefixCls}-close-icon`} tabIndex={0}>
        {closeText ? (<span className={`${prefixCls}-close-text`}>{closeText}</span>) : (<CloseOutlined />)}
      </button>) : null;
        }
        render() {
            return <ConfigConsumer>{this.renderAlert}</ConfigConsumer>;
        }
    }
    Alert.ErrorBoundary = ErrorBoundary;
    return Alert;
})();
export default Alert;
